import axios from 'axios';
import { Message } from 'element-ui';

// const isDev = process.env.NODE_ENV === 'development';
// const baseURL = isDev
//   ? process.env.VUE_APP_API_BASE_URL
//   : process.env.VUE_APP_API_HOST + process.env.VUE_APP_API_BASE_URL;
const baseURL = process.env.VUE_APP_API_HOST + process.env.VUE_APP_API_BASE_URL;

const service = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  // withCredentials: true // send cookies when cross-domain requests
});

service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  function(response) {
    // http请求状态码2xx
    return response;
  },
  function(error) {
    // http请求状态码 不是 2xx
    Message({
      message: error.message || '网络错误',
      type: 'error',
      duration: 3 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
